module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-444.a341348.woff2";